var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      key: _vm.resetKey,
      staticClass: "countdown d-flex flex-row justify-content-center",
      class: { "d-none": !_vm.isCounterAvailable }
    },
    [
      _c("div", [
        _c("span", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.display(_vm.days)))
        ]),
        _c("span", { staticClass: "unit" }, [_vm._v("d")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.display(_vm.hours)))
        ]),
        _c("span", { staticClass: "unit" }, [_vm._v("h")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.display(_vm.minutes)))
        ]),
        _c("span", { staticClass: "unit" }, [_vm._v("m")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.display(_vm.seconds)))
        ]),
        _c("span", { staticClass: "unit" }, [_vm._v("s")])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }